<!-- tableboard.vue -->

<template>
  <div>
    <Tables ref="tableGridsBoardDiversosPretacaoDeContas"
      :columns="['Lote' ,'Data de Lançamento', 'Funcionários Vinculados', 'Valor Total']"
      :showSearch="false"
      :showPrint="false"
      :newHeaderStatus="true"
      :showDownload="false"
      :showCheckInput="true"
      @check="CheckAll"
      :showFullscreen="false"
      v-on:Load="onLoad"
      >
      <tr v-for="obj in dataFucionario" :key="obj.id">
        <td class="text-center" style="font-size: 20px; vertical-align: middle;"><input :id="obj.id" type="checkbox" class="checkbox-cus"/></td>
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.lote" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="returnFormatedData(obj.dataIncluaoLote)" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.funcionariosVinculados" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="formatMoney(obj.totalGasto)" />
      </tr>
      <template #ButtonsAprova>
          <button @click="modalReprove" class="reprova"><i class="fas fa-thumbs-down mr-1" ></i>REPROVAR</button>
          <button @click="apprBoard" class="button-apr"><i class="fas fa-thumbs-up ml-1" ></i>APROVAR</button>
        </template>
      </Tables>
      <b-modal ref="modal-EscolhaReprova"
        size="md"
        centered
        id="add-brower-modal"
        title="Reprovação"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <div class="icone-reprova">
          <i class="fas fa-thumbs-down"></i>
        </div>
        <div>
          <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
        </div>
        <div class="conteiner pt-3">
          <button  @click="modalDevolucao(loteid)" class="button-info">DEVOLUÇÃO</button>
          <button  @click="modalDefinitivo(loteid)" class="button-reprova">DEFINITIVA</button>
        </div>
      </b-modal>
      <b-modal
          ref="devolver-despesa"
          size="md"
          centered
          id="add-brower-modal"
          title="Devolução da Lote"
          :hide-footer="true"
          :clickToClose="false"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          :hide-header-close="true"
        >
          <div>
              <!-- <div class="conteiner"><i class="fa fa-window-close icone"></i></div> -->
              <div class="label conteiner">Informe o motivo da devolução!</div>
              <div class="caxa-texto conteiner">
                  <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
              </div>
          </div>
          <div class="conteiner pt-3">
              <button @click="backModal(loteid)" class="button-cancel">VOLTAR</button>
              <button @click="RepListLoteBoard(loteid)" class="button-save">SALVAR</button>
          </div>
        </b-modal>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'

export default {
  name: 'tableboard',
  mixins: [ActionsForm],
  props: {
    shouldSearch: {
      type: Boolean,
      default: false
    },
    Id: {
      type: String,
      default: null
    },
    Lote: {
      type: String,
      default: ''
    }
  },
  watch: {
    shouldSearch () {
      this.onLoad(this.Id)
    }
  },
  data () {
    return {
      dataFucionario: [],
      formSearch: {},
      dataCoordenador: '',
      dataControladoria: '',
      definitivo: null,
      motivo: null,
      listCheck: [],
      loteid: ''
    }
  },
  methods: {
    uncheckAllCheckboxes () {
      var checkboxes = document.querySelectorAll('.checkbox-cus')
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false
      })
    },
    onLoad (Id = null) {
      this.formSearch.Id = Id
      this.formSearch.EmpresaId = this.CompanySelected
      if (this.Lote != null) {
        this.formSearch.Lote = parseInt(this.Lote)
      }
      loading.push()
      MiscellaneousExpensesRepository.GetAllFuncionarioBoard(this.formSearch)
        .then((Response) => {
          this.dataFucionario = []
          loading.pop()
          let data = Response.data.data
          let somadespesa = Response.data.data.map((element) => element.totalGasto)
          let totalSum = somadespesa.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
          this.$emit('despesaDiversosValorTotal', totalSum)
          this.$refs.tableGridsBoardDiversosPretacaoDeContas.LoadAllByData(Response)
          this.dataFucionario = data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    returnFormatedData (value) {
      let data = new Date(value)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },
    returnFormatedDataControladoria (value) {
      let data = new Date(value)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    CheckAll (value) {
      let checkboxes = document.querySelectorAll('.checkbox-cus')
      checkboxes.forEach((checkbox) => {
        checkbox.checked = value.checked
      })
    },
    apprBoard () {
      loading.push()
      let data = []
      let lote = document.querySelectorAll('.checkbox-cus')
      lote.forEach((e) => {
        if (e !== undefined || e !== null) {
          if (e.checked) data.push(e.id)
        }
      })
      MiscellaneousExpensesRepository.ApprListBoard({loteid: data})
        .then((Response) => {
          loading.pop()
          this.uncheckAllCheckboxes()
          this.onLoad()
          toast.success('Despesa Aprovada com sucesso')
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Erro')
        })
    },
    RepListBoard () {
      loading.push()
      let data = new FormData()
      this.dataFucionario.forEach((Element) => {
        let check = document.getElementById(Element)
        if (check !== undefined) {
          if (check.checked) data.append('despesasdiversosids', Element.Id)
        }
      })
      console.log(this.dataFucionario)
      MiscellaneousExpensesRepository.RepListBoard(data)
        .then((Response) => {
          loading.pop()
          this.uncheckAllCheckboxes()
          this.onLoad()
          toast.success('Lote Reprovado com sucesso')
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Erro ao reprovar o Lote')
        })
    },
    onSelect (data) {
      console.log(data)
      this.$router.push(`/financeiro/prestacao-conta/lote?lote=${data.id}`)
    },
    modalReprove () {
      let checkboxes = document.querySelectorAll('.checkbox-cus')
      console.log(checkboxes)
      this.$refs['modal-EscolhaReprova'].show()
    },
    modalDevolucao (loteid) {
      this.definitivo = false
      this.$refs['devolver-despesa'].show(this.loteid)
    },
    modalDefinitivo () {
      this.definitivo = true
      this.$refs['devolver-despesa'].show(this.loteid)
    },
    backModal () {
      this.motivo = null
      this.$refs['devolver-despesa'].hide()
      this.$refs['modal-EscolhaReprova'].show(this.loteid)
    },
    RepListLoteBoard () {
      loading.push()
      let data = []
      let lote = document.querySelectorAll('.checkbox-cus')
      lote.forEach((e) => {
        console.log(e)
        if (e !== undefined || e !== null) {
          if (e.checked) data.push(e.id)
        }
      })
      if (data.length >= 1) {
        MiscellaneousExpensesRepository.RepListBoard({motivoRecusa: this.motivo, ReprovacaoDefinitiva: this.definitivo, loteid: data})
          .then((Response) => {
            loading.pop()
            this.uncheckAllCheckboxes()
            this.onLoad()
            toast.success('Lote(s) Reprovado(s) com sucesso')
            this.$refs['devolver-despesa'].hide()
            this.$refs['modal-EscolhaReprova'].hide()
            this.motivo = null
          })
          .catch((Error) => {
            loading.pop()
            toast.error('Erro ao reprovar o(s) Lote(s)')
          })
      } else {
        toast.warning('Selecione no mínimo um Lote')
      }
    }
  }
}

</script>

<style scoped>
.checkbox-cus{
    width: 20px !important;
}
.button-apr{
    height: 2rem;
    background: #008144;
    width: 150px;
    color: white;
    border: none;
    border-radius: 10px;
}
.button-apr:hover{
    background: #016436;
}
.reprova{
    height: 2rem;
    background: red;
    width: 150px;
    color: white;
    border: none;
    border-radius: 10px;
}
.reprova:hover{
    background: rgb(214, 1, 1);
}

.icone-reprova{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
}
.labelmodal{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}
.conteiner{
    display: flex;
    gap: 4rem;
    justify-content: center;
}
.button-info{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(208 195 43);
}
.button-reprova{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}

.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tableboard/tableboard.vue